import { Injectable } from '@angular/core';
import { Lookup } from '@common/utilities/Lookup';
import { ApiService } from './api.service';
import { DataService, ServiceRecord, ServiceGroupRecord } from './data.service';
import { SynchronizationService } from './synchronization.service';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {

  private lookupById = new Lookup<ServiceRecord>(i => i.ID);

  private _sync(notify = true) {

    if (notify) this.sync.notify(ServicesService, false);    

    this.ds.services('list').subscribe(services => {

      if (services) {
        this.lookupById.source = services;

        this.sync.notify(ServicesService, true);
      }
      else {
        if (this.api.authorized) {
          this._sync(false);
        }
        else {
          this.api.credentialChanged.subscribe(user => {
            this._sync(false);
          });
        }
      }
    });
  }

  public synchronize() {
    this._sync();
  }

  private clone(service: ServiceRecord): ServiceRecord {
    return service ? { ...service } : null;
  }

  public get(id: number): ServiceRecord {
    return this.lookupById.get(id, null);
  }

  public getByGroup(group: ServiceGroupRecord | number): ServiceRecord[] {
    switch (typeof group) {
      case 'number': return this.all.filter(i => i.GroupID == group);
      default: return this.getByGroup(group.ID);
    }
  }

  public get all(): ServiceRecord[] {
    return this.lookupById.source.map(i => this.clone(i));
  }

  constructor(private ds: DataService, private api: ApiService, private sync: SynchronizationService) {
    this._sync();
  }
}
